import   axios                from 'axios';

import { API_URLS           } from '../urls';
import { BackendResponse    ,
         handleError        } from '../../dataTypes/backendServicesManagment/types';

import { Subscription       } from '../../dataTypes/subscriptionManagment/types';

const transformSubscription = (data: any): Subscription => ({
  id                      : data.id ,
  productName             : data.productName ?? null ,
  productVariantName      : data.productVariantName ?? null ,
  associatedAdminResource : data.associatedAdminResource ?? null ,
  bankCode                : data.bankCode ?? null ,
  status                  : data.status ,
  amount                  : data.amount ,
  creationDate            : data.creationDate     ? new Date(data.creationDate)     : null ,
  lastRenewedDate         : data.lastRenewedDate  ? new Date(data.lastRenewedDate)  : null ,
  cancelledDate           : data.cancelledDate    ? new Date(data.cancelledDate)    : null ,
  paymentFailureCount     : data.paymentFailureCount ?? 0 ,
  lastPaymentFailureDate  : data.lastPaymentFailureDate ? new Date(data.lastPaymentFailureDate) : null ,
});

export interface BackendResponse_SubscriptionList extends BackendResponse<Subscription[]> {}

export const getSubscriptions = async (email: string): Promise<BackendResponse_SubscriptionList> => {

  const url = `${API_URLS.getSubscriptionInfosByEmail}?email=${encodeURIComponent(email)}`;

  try {
    const response = await axios.get(url);

    if (response.status === 200 && Array.isArray(response.data)) {
      return {
        code: 1,
        comment: 'Les abonnements ont été récupérés avec succès.',
        payload: response.data.map(transformSubscription),
      };
    } else {
      return handleError<Subscription[]>(response.status, 'Réponse non-200.', []);
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<Subscription[]>(-101, error.response?.data?.detail ?? error.message, []);
    }
    return handleError<Subscription[]>(-102, 'Erreur inconnue.', []);
  }
};

// ── Création d'un abonnement ─────────────────────────────────────────────────
//
// Pas de panier ici, à la différence de createPayment : la ressource et son prix
// viennent directement du catalogue (productVariantCode + priceCode) — cf.
// SubscriptionCreation.php. Retourne l'url de redirection banque (même forme que
// createPayment, mais dans response.data.url plutôt qu'un payload de type string
// puisque SubscriptionCreation renvoie l'entité Subscription entière).

export interface BackendResponse_SubscriptionUrl extends BackendResponse<string> {}

export const createSubscription = async ( productVariantCode: string ,
                                          priceCode:          string ,
                                          bankCode:           string ,
                                          userEmail:          string ,
                                          comment:            string ): Promise<BackendResponse_SubscriptionUrl> => {

  const url = API_URLS.postSubscriptionCreation;

  try {
    const response = await axios.post(
      url,
      { productVariantCode, priceCode, bankCode, userEmail, comment },
      { headers: { 'Accept': 'application/ld+json', 'Content-Type': 'application/ld+json' } }
    );

    if (response.status === 201 && response.data?.url) {
      return { code: 1, comment: "Abonnement créé.", payload: response.data.url };
    }
    return handleError<string>(response.status, 'Réponse non-201 ou url manquante.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<string>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<string>(-102, 'Erreur inconnue.');
  }
};

export interface BackendResponse_Void extends BackendResponse<null> {}

export const cancelSubscription = async (subscriptionId: number): Promise<BackendResponse_Void> => {

  const url = API_URLS.postCancelSubscription.replace('{id}', `${subscriptionId}`);

  try {
    const response = await axios.post(url);

    if (response.status === 200 && response.data?.code === 1) {
      return { code: 1, comment: response.data?.comment ?? 'Résiliation demandée.', payload: null };
    }
    return handleError<null>(response.status, response.data?.comment ?? 'Réponse non-200.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<null>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<null>(-102, 'Erreur inconnue.');
  }
};
